import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ShoppingCart } from 'lucide-react';
const faqs = [{
  question: '¿Para quién es este pack?',
  answer: 'Está diseñado específicamente para mujeres que sienten que las finanzas no son lo suyo, que viven al día o tienen ingresos variables. No necesitas conocimientos previos de contabilidad ni matemáticas.'
}, {
  question: '¿Necesito mucho tiempo para aplicarlo?',
  answer: 'No. El método está creado para mujeres ocupadas. El reto de 30 días solo requiere 15 minutos diarios de lectura y ejercicios prácticos.'
}, {
  question: '¿Sirve si tengo ingresos variables?',
  answer: '¡Absolutamente! De hecho, es ideal para ti. Incluimos estrategias específicas para manejar la incertidumbre de los ingresos variables (freelancers, emprendedoras, ventas).'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Es un producto 100% digital. Inmediatamente después de tu compra, recibirás un correo con el acceso a la plataforma donde podrás descargar todos los PDFs y guías.'
}, {
  question: '¿Tengo que imprimir todo?',
  answer: "No es obligatorio. Los PDFs son interactivos y puedes llenarlos desde tu computadora o tablet. Sin embargo, recomendamos imprimir el 'Diario de Dinero' para tener una experiencia más tangible."
}, {
  question: '¿Incluye asesoría personalizada?',
  answer: 'Este es un pack de autoestudio diseñado para ser muy claro y fácil de seguir por tu cuenta. No incluye sesiones 1 a 1, pero el material cubre las dudas más frecuentes paso a paso.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-20 bg-gray-50" data-id="element-53">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-56">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-57">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-59">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-60">
                <span className="font-bold text-[#1e3a5f] text-lg" data-id="element-61">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4a574] transition-transform duration-300 ${activeIndex === index ? 'transform rotate-180' : ''}`} data-id="element-62" />
              </button>

              <AnimatePresence data-id="element-63">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-64">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-65">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center" data-id="element-66">
          <div className="mb-6" data-id="element-67">
            <p className="text-gray-600 text-lg mb-2" data-id="element-68">
              ¿Lista para tomar el control de tus finanzas?
            </p>
            <div className="flex items-baseline justify-center gap-3" data-id="element-69">
              <span className="text-4xl font-bold text-[#1e3a5f]" data-id="element-70">
                $9.95 USD
              </span>
              <span className="text-[#d4a574] font-semibold text-sm bg-[#d4a574]/10 px-3 py-1 rounded-lg" data-id="element-71">
                96% OFF
              </span>
            </div>
            <p className="text-sm text-gray-500 italic mt-2" data-id="element-72">
              *Oferta de lanzamiento por tiempo limitado
            </p>
          </div>

          <motion.a href="https://mikioscodigital.com/cart/51754595811609:1" whileHover={{
          scale: 1.1,
          y: -6
        }} whileTap={{
          scale: 0.92,
          y: 2
        }} className="group relative inline-block" style={{
          perspective: '1000px'
        }} data-id="element-73">
            {/* Enhanced Multiple 3D Shadow Layers - More Luminous */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#f4d03f] to-[#d4a574] rounded-2xl translate-y-4 blur-2xl opacity-70 group-hover:translate-y-5 group-hover:opacity-90 transition-all duration-300" data-id="element-74" />
            <div className="absolute inset-0 bg-gradient-to-br from-[#d4a574] to-[#c29463] rounded-2xl translate-y-2 blur-xl opacity-60 group-hover:translate-y-3 group-hover:opacity-80 transition-all duration-300" data-id="element-75" />
            <div className="absolute inset-0 bg-[#f4d03f] rounded-2xl translate-y-1 blur-lg opacity-50 group-hover:translate-y-2 group-hover:opacity-70 transition-all duration-300" data-id="element-76" />

            {/* Pulsing Outer Glow Animation */}
            <motion.div className="absolute inset-0 rounded-2xl" animate={{
            boxShadow: ['0 0 40px rgba(244, 208, 63, 0.6), 0 0 80px rgba(212, 165, 116, 0.4)', '0 0 60px rgba(244, 208, 63, 0.8), 0 0 120px rgba(212, 165, 116, 0.6)', '0 0 40px rgba(244, 208, 63, 0.6), 0 0 80px rgba(212, 165, 116, 0.4)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-77" />

            {/* Main 3D Button - Ultra Bright */}
            <div className="relative bg-gradient-to-br from-[#f4d03f] via-[#ffd700] to-[#d4a574] p-[4px] rounded-2xl shadow-2xl group-hover:shadow-[0_30px_60px_rgba(244,208,63,0.8)] transition-all duration-300" data-id="element-78">
              {/* Enhanced Inner glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-black/5 rounded-2xl" data-id="element-79" />

              <div className="relative bg-gradient-to-br from-[#f4d03f] via-[#ffd700] to-[#d4a574] rounded-2xl overflow-hidden" data-id="element-80">
                {/* Ultra Bright animated shine effect */}
                <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent" animate={{
                x: ['-100%', '200%']
              }} transition={{
                duration: 2,
                repeat: Infinity,
                repeatDelay: 1,
                ease: 'easeInOut'
              }} data-id="element-81" />

                {/* Multiple radial highlights for extra luminosity */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-3/4 bg-gradient-radial from-white/50 to-transparent blur-2xl" data-id="element-82" />
                <div className="absolute top-1/4 left-1/4 w-1/2 h-1/2 bg-white/30 rounded-full blur-3xl" data-id="element-83" />

                {/* Sparkle effect */}
                <motion.div className="absolute top-2 right-2 w-2 h-2 bg-white rounded-full" animate={{
                opacity: [0, 1, 0],
                scale: [0.5, 1, 0.5]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatDelay: 0.5
              }} data-id="element-84" />
                <motion.div className="absolute bottom-3 left-3 w-1.5 h-1.5 bg-white rounded-full" animate={{
                opacity: [0, 1, 0],
                scale: [0.5, 1, 0.5]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatDelay: 1
              }} data-id="element-85" />

                <div className="relative px-10 py-6 flex items-center justify-center gap-4 group-hover:scale-[1.03] transition-transform duration-300" data-id="element-86">
                  <motion.div whileHover={{
                  rotate: [0, -15, 15, -15, 0]
                }} transition={{
                  duration: 0.6
                }} data-id="element-87">
                    <ShoppingCart className="w-8 h-8 text-[#1e3a5f] drop-shadow-lg" data-id="element-88" />
                  </motion.div>
                  <div className="flex flex-col items-start" data-id="element-89">
                    <span className="text-[#1e3a5f] font-bold text-xl leading-tight drop-shadow-md" data-id="element-90">
                      ¡Sí, Quiero Transformar
                    </span>
                    <span className="text-[#1e3a5f] font-bold text-xl leading-tight drop-shadow-md" data-id="element-91">
                      Mis Finanzas Ahora!
                    </span>
                    <span className="text-[#1e3a5f]/90 text-sm font-bold mt-1 drop-shadow-sm" data-id="element-92">
                      🔥 Solo $9.95 USD - Oferta Limitada
                    </span>
                  </div>
                </div>

                {/* Enhanced bottom edge highlight */}
                <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-black/30 to-transparent" data-id="element-93" />
              </div>
            </div>

            {/* Ultra bright outer glow on hover */}
            <motion.div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
            boxShadow: '0 0 60px rgba(244, 208, 63, 0.8), 0 0 120px rgba(255, 215, 0, 0.6), 0 0 180px rgba(212, 165, 116, 0.4)'
          }} data-id="element-94" />
          </motion.a>

          <p className="text-sm text-gray-500 mt-6" data-id="element-95">
            Acceso inmediato • Garantía de 30 días • Pago seguro
          </p>
        </motion.div>
      </div>
    </section>;
}